import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { sortBy } from 'lodash'
import React, { FC, useEffect, useRef, useState } from 'react'
import { compile } from '../../../utils/search'

interface Props {
  selectList: { id: number, name: string }[]
  serviceList: { id: number, name: string }[]
  callbackApps: (Apps: { id: number, name: string }[]) => void
  isClear?: boolean
  disabled?: boolean
}

const DISPLAY_LIMIT = 100

const AddAppModule: FC<Props> = (props) => {
  const {
    selectList,
    serviceList,
    callbackApps,
    isClear,
    disabled,
  } = props

  const IMITATION = [
    {
      id: -1,
      name: "Chrome",
    },
    {
      id: -2,
      name: "Edge",
    },
    {
      id: -3,
      name: "Firefox",
    },
  ]

  const scrollRef = useRef<HTMLDivElement>(null)

  const [isSearchDisplay, setIsSearchDisplay] = useState(false)
  const [selectAppIds, setSelectAppIds] = useState<number[]>([])
  const [apps, setApps] = useState<{ id: number, name: string }[]>([])
  const [searchAppWord, setSearchAppWord] = useState<string>("")
  const [displayCount, setDisplayCount] = useState<number>(1)

  const appsInit = [...serviceList, ...IMITATION]

  const clickApp = (appId: number) => {
    if (selectAppIds.includes(appId)) {
      setSelectAppIds((cur) => cur.filter((id) => id !== appId))
    } else {
      setSelectAppIds((cur) => [...cur, appId])
    }
  }

  const searchApp = (words: string) => {
    if (scrollRef.current) scrollRef.current.scrollTo({ top: 0, behavior: 'auto' })
    setDisplayCount(1)
    setSearchAppWord(words)
    if (!words) {
      setApps([...appsInit])
      return
    }
    const word = words.toLowerCase().split(/\s+/)
    const list = appsInit.filter((app) => {
      if (app === null) return false
      return (compile(word).test(app.name.toLowerCase()))
    })
    setApps(sortBy(list, 'id'))
  }

  const resetApp = () => {
    setSearchAppWord("")
    setApps([...appsInit])
    setDisplayCount(1)
  }

  const openSearch = () => {
    if (disabled) return
    setIsSearchDisplay(true)
    setDisplayCount(1)
  }

  const closeSearch = () => {
    setIsSearchDisplay(false)
    resetApp()
    callbackApps(appsInit.filter((v) => selectAppIds.includes(v.id)))
  }

  const handleScroll = () => {
    const element = scrollRef.current
    if (!element) return

    const { scrollTop, clientHeight, scrollHeight } = element
    const isBottom = scrollTop + clientHeight >= scrollHeight - 10

    if (isBottom) {
      setDisplayCount((cur) => cur + 1)
    }
  }

  useEffect(() => {
    setApps([...appsInit])
  }, [serviceList])

  useEffect(() => {
    setSelectAppIds(selectList.map((v) => v.id))
  }, [selectList])

  useEffect(() => {
    if (!isClear) return
    setSelectAppIds([])
  }, [isClear])

  return (
    <>
      <div
        style={{
          backgroundColor: "#D5E8D4",
          color: "#82B366",
          borderRadius: "20px",
          padding: "4px 8px",
          display: "inline-block",
          marginRight: "8px",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.5 : 1,
          position: "relative",
        }}
        onClick={() => openSearch()}
        role="none"
      >
        <FontAwesomeIcon icon={['fas', 'plus']} />
        &nbsp;
        追加
        {
          isSearchDisplay && (
            <div
              className={`search_box ${isSearchDisplay || 'none'}`}
              style={{
                top: "30px",
                right: "unset",
                border: "solid 1px #CCCCCC",
                color: "#666666",
                cursor: "initial",
              }}
            >
              <div
                className="search_detail"
                style={{
                  width: "600px",
                }}
              >
                <div
                  className="category"
                >
                  <div
                    style={{
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <div className="category_title">
                      アプリケーション
                      {
                        apps.length ? (
                          <div
                            className="select_reset"
                            role="none"
                            onClick={() => setSelectAppIds([])}
                          >
                            リセット
                          </div>
                        ) : (
                          <></>
                        )
                      }
                    </div>
                    <div className="search_area">
                      <FontAwesomeIcon
                        icon={['fas', 'search']}
                        className="icon"
                      />
                      <input
                        type="text"
                        placeholder="アプリを検索"
                        onChange={(event) => searchApp(event.target.value)}
                        value={searchAppWord}
                      />
                      {
                        searchAppWord && (
                          <button type="button" className="reset" onClick={resetApp}>
                            <FontAwesomeIcon icon={['far', 'times-circle']} />
                          </button>
                        )
                      }
                    </div>
                  </div>
                  {
                    !apps.length ? (
                      <div
                        style={{
                          backgroundColor: "#F7F7F7",
                          border: "solid 1px #CCCCCC",
                          borderRadius: "4px",
                          padding: "8px",
                        }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: "8px",
                            fontWeight: "bold",
                            color: "#FF0000",
                          }}
                        >
                          選択できるアプリケーションがありませんでした
                        </div>
                      </div>
                    ) : (
                      <>
                        <div
                          className="chip_list"
                          style={{
                            maxHeight: "160px",
                            overflowY: "scroll",
                            scrollbarWidth: "none",
                          }}
                          ref={scrollRef}
                          onScroll={handleScroll}
                        >
                          {
                            apps.slice(0, DISPLAY_LIMIT * displayCount).map((app) => (
                              <button
                                type="button"
                                className={`chip ${selectAppIds.includes(app.id) ? "checked" : ""}`}
                                key={`app_id_${app.id}`}
                                onClick={() => clickApp(app.id)}
                              >
                                {app.name}
                              </button>
                            ))
                          }
                        </div>
                      </>
                    )
                  }
                </div>
              </div>
            </div>
          )
        }
      </div>
      <div className={`close_screen ${isSearchDisplay || 'none'}`} role="presentation" onClick={() => closeSearch()} />
    </>
  )
}

AddAppModule.defaultProps = {
  isClear: false,
  disabled: false,
}

export default AddAppModule
